import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Instagram, Facebook } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function Footer() {
    const c = useContent();
    const g = c.global || {};
    const f = c.footer || {};
    return (
        <footer className="mt-24 border-t border-brand-line bg-brand-charcoal">
            <div className="container-wide py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
                <div>
                    <img src={g.logo_url} alt="Umami Kraft" className="h-16 w-auto object-contain [filter:invert(1)_hue-rotate(180deg)_saturate(1.4)]" />
                    <p className="text-sm text-brand-mute mt-4 leading-relaxed">
                        {f.tagline}
                    </p>
                    {g.show_halaal_header !== false && g.halaal_logo_url && (
                        <div className="mt-4 flex items-center gap-2">
                            <img src={g.halaal_logo_url} alt="Halaal Certified" className="h-10 w-auto object-contain" />
                            <p className="text-[10px] tracking-[0.2em] uppercase text-brand-gold">{g.halaal_caption}</p>
                        </div>
                    )}
                </div>

                <div>
                    <p className="text-xs tracking-[0.2em] text-brand-gold uppercase mb-4">{f.visit_heading || "Visit"}</p>
                    <div className="flex items-start gap-2 text-sm text-brand-cream/80">
                        <MapPin size={16} className="mt-0.5 text-brand-olive" />
                        <span>{g.address_line1}<br />{g.address_line2}</span>
                    </div>
                    <div className="flex items-center gap-2 text-sm text-brand-cream/80 mt-3">
                        <Phone size={16} className="text-brand-olive" />
                        <a href={`tel:${g.phone_tel}`} className="hover:text-brand-gold">{g.phone_display}</a>
                    </div>
                </div>

                <div>
                    <p className="text-xs tracking-[0.2em] text-brand-gold uppercase mb-4">{f.hours_heading || "Hours"}</p>
                    <div className="flex items-start gap-2 text-sm text-brand-cream/80">
                        <Clock size={16} className="mt-0.5 text-brand-olive" />
                        <div>
                            {(g.hours_lines || []).map((line, i) => (
                                <div key={i}>{line}</div>
                            ))}
                        </div>
                    </div>
                </div>

                <div>
                    <p className="text-xs tracking-[0.2em] text-brand-gold uppercase mb-4">{f.explore_heading || "Explore"}</p>
                    <ul className="space-y-2 text-sm text-brand-cream/80">
                        <li><Link className="hover:text-brand-gold" to="/order">Menu</Link></li>
                        <li><Link className="hover:text-brand-gold" to="/specials">Specials & Bundles</Link></li>
                        <li><Link className="hover:text-brand-gold" to="/about">About</Link></li>
                        <li><Link className="hover:text-brand-gold" to="/contact">Contact</Link></li>
                    </ul>
                    <div className="flex gap-3 mt-6">
                        <a href="#" className="text-brand-cream/60 hover:text-brand-gold"><Instagram size={18} /></a>
                        <a href="#" className="text-brand-cream/60 hover:text-brand-gold"><Facebook size={18} /></a>
                    </div>
                </div>
            </div>
            <div className="border-t border-brand-line">
                <div className="container-wide py-5 text-xs text-brand-mute flex justify-between">
                    <span>© {new Date().getFullYear()} Umami Kraft. All rights reserved.</span>
                    <Link to="/admin" className="hover:text-brand-gold">Owner Login</Link>
                </div>
            </div>
        </footer>
    );
}
